import { render, staticRenderFns } from "./BulkUploadFullTextPdfController.vue?vue&type=template&id=6633fe77&"
import script from "./BulkUploadFullTextPdfController.vue?vue&type=script&lang=js&"
export * from "./BulkUploadFullTextPdfController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports